import React from 'react';
import { motion } from 'framer-motion';
import { FlowLine } from './FlowLine';
const volumeNames = ['Fondamentaux & Placement', 'Travail à la Barre', 'Travail au Centre', 'Pirouettes, Tours, Sauts & Allegro', 'Progressions, Niveaux, Corrections & Évaluation', '150 Cours Prêts à Enseigner'];
const visualItems = ['séquences techniques étape par étape', 'positions des pieds et des bras', 'axes corporels', 'directions de rotation', 'trajectoires', 'progressions techniques', 'comparaisons correct / incorrect', 'erreurs fréquentes', 'corrections', 'exercices structurés', 'circuits pédagogiques', 'checklists', 'fiches de cours', 'évaluations', 'outils de référence'];
export function SystemOverview() {
  return <section className="bg-brand-cream px-4 py-20 sm:py-28" data-id="element-252" data-mp="yzfsd98kz52l">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-[1fr_1.1fr] lg:gap-16" data-id="element-253" data-mp="2fa1k2vc2zrah">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-254" data-mp="2ab6unajlz4he">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-brand-deep" data-id="element-255" data-mp="283w7411a9mn5">
            Un système complet 6-en-1
          </p>
          <h2 className="mt-3 text-3xl font-semibold leading-tight text-brand-ink sm:text-4xl" data-id="element-256" data-mp="2i3d9a8hbtied">
            Vous ne recevez pas un simple guide.
          </h2>
          <p className="mt-4 text-base leading-7 text-brand-muted" data-id="element-257" data-mp="1khplud2umaez">
            Vous accédez à 6 volumes complémentaires, chacun conçu pour
            répondre à une partie différente de votre enseignement.
          </p>
          <ol className="mt-8 divide-y divide-brand-line border-y border-brand-line" data-id="element-258" data-mp="1uc7rvovqmi1y">
            {volumeNames.map((name, index) => <li key={name} className="flex items-baseline gap-4 py-3.5" data-id="element-259" data-mp="11q6jm8gnf0e0" data-mpi={index}>
                <span className="w-6 shrink-0 font-display text-2xl font-semibold text-brand-coral" data-id="element-260" data-mp="16o832uhzl1q0">
                  {index + 1}
                </span>
                <span className="text-base font-medium text-brand-ink" data-id="element-261" data-mp="ym7i8tziri78">
                  {name}
                </span>
              </li>)}
          </ol>
          <p className="mt-5 text-sm font-semibold text-brand-deep" data-id="element-262" data-mp="18dv4mgh7y91u">
            Tout est organisé pour fonctionner comme un seul système.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border border-brand-line bg-white p-6 shadow-card sm:p-9" data-id="element-263" data-mp="foxtqyfc7ej4">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-brand-deep" data-id="element-264" data-mp="knraczpx7lni">
            Entièrement visuel
          </p>
          <p className="mt-3 text-base leading-7 text-brand-muted" data-id="element-265" data-mp="210futdlykf3t">
            Le contenu principal a été conçu pour permettre au professeur de
            comprendre rapidement quoi enseigner et comment l’appliquer.
          </p>
          <p className="mt-6 text-sm font-semibold text-brand-ink" data-id="element-266" data-mp="28ls4cjpbznbb">
            Vous trouverez notamment :
          </p>
          <ul className="mt-3 flex flex-wrap gap-2" data-id="element-267" data-mp="1umiqhqoll5ai">
            {visualItems.map(item => <li key={item} className="rounded-full border border-brand-rose/50 bg-brand-blush px-3 py-1.5 text-xs font-medium text-brand-ink" data-id="element-268" data-mp="1yn2kildvjssf">
                {item}
              </li>)}
          </ul>
          <FlowLine className="mt-8 border-t border-brand-line pt-6" steps={['Ouvrir', 'Observer', 'Comprendre', 'Enseigner', 'Corriger', 'Faire progresser']} data-id="element-269" data-mp="2redxuxcrn1sq" />
        </motion.div>
      </div>
    </section>;
}